import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../utils/const";
import SalesRecruiter from "../../components/common/SalesRecruiter";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import styles from "./MassMailing.module.css";
import profile_image from "../../assets/images/ajit_image.jpeg";
import { TiTick } from "react-icons/ti";
import { useEffect, useState } from "react";
import {
  getAllRecruiterCandidate,
  getAllRecruiterCandidateNextPrevious,
  postMassmail,
} from "../../redux/massmail/massmailSlice";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";

function ActiveBenchSalesDrawer({
  handleClose,
  show,
  jobID,
  valueData,
  candidateData,
}) {
  const massmailStatus = useSelector((state) => state.massmail.status);
  const [candidates, setCandidates] = useState([]);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [page, setPage] = useState(1);
  const [hasNext, setHasNext] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (jobID && Object.keys(jobID).length > 0) {
      let jobDetails = `job_id=${jobID?.job_id}&skills=${encodeURIComponent(
        JSON.stringify(jobID.skills)
      )}`;
      setPage(1);
      setCandidates([]);
      fetchCandidates(jobDetails, 1);
    }
  }, [jobID]);

  const fetchCandidates = (jobDetails, pageNumber = 1) => {
    const query = `${jobDetails}&page=${pageNumber}`;
    dispatch(getAllRecruiterCandidate(query)).then((res) => {
      if (res.payload?.results) {
        setCandidates((prev) =>
          pageNumber === 1
            ? res.payload.results
            : [...prev, ...res.payload.results]
        );
        setHasNext(res.payload.has_next);
      }
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (candidateData?.results?.length > 0) {
      setCandidates(candidateData?.results);
    }
  }, [candidateData]);

  const handleSelect = (id) => {
    const updatedCandidates = candidates.map((candidate) =>
      candidate?.recruiter_id === id
        ? { ...candidate, selected: !candidate.selected }
        : candidate
    );
    setCandidates(updatedCandidates);
    setSelectAll(updatedCandidates.every((candidate) => candidate.selected));
  };

  // const handleSelect = (id) => {
  //   const updatedCandidates = candidates.map((candidate) =>
  //     candidate.candidates.some(c => c.id === id)
  //       ? { ...candidate, selected: !candidate.selected }
  //       : candidate
  //   );
  //   setCandidates(updatedCandidates);
  //   setSelectAll(updatedCandidates.every((candidate) => candidate.selected));
  // };

  const handleSelectAll = () => {
    const updatedSelectAll = !selectAll;
    setSelectAll(updatedSelectAll);
    const updatedCandidates = candidates.map((candidate) => ({
      ...candidate,
      selected: updatedSelectAll,
    }));
    setCandidates(updatedCandidates);
  };

  const handleOnClickMassmail = () => {
    const selectedIds = candidates
      .filter((candidate) => candidate.selected)
      .flatMap((recruiter) => recruiter.candidates.map((c) => c.id));
    let userData = {
      ...valueData,
      job_id: jobID?.job_id,
      send_both: true,
      candidate_resume_ids: selectedIds,
    };

    dispatch(postMassmail(userData));
  };

  const handleOnClickNextPrevious = (type) => {
    if (type === "next") {
      let url = candidateData?.next;
      dispatch(getAllRecruiterCandidateNextPrevious(url));
    } else {
      let url = candidateData?.previous;
      dispatch(getAllRecruiterCandidateNextPrevious(url));
    }
    setSelectAll(false);
  };

  const totalSelectedCredit = candidates
    .filter((recruiter) => recruiter.selected) // Get selected recruiters
    .flatMap((recruiter) => recruiter.candidates) // Extract all candidates under selected recruiters
    .reduce((sum, candidate) => sum + (candidate.credit || 0), 0); // Sum up the credit values

  useEffect(() => {
    if (massmailStatus === "post_massmail_succeeded") {
      handleCloseModal();
      handleClose();
    }
  }, [massmailStatus]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "570px",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Offcanvas.Title style={{ fontWeight: "600", color: customTextColor }}>
          All Active Bench Sales Recruiter
        </Offcanvas.Title>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Box className={styles.requiter_profile_section}>
          {candidates?.length > 0 ? (
            <InfiniteScroll
              dataLength={candidates.length}
              next={() => {
                if (hasNext) {
                  const nextPage = page + 1;
                  let jobDetails = `job_id=${
                    jobID?.job_id
                  }&skills=${encodeURIComponent(JSON.stringify(jobID.skills))}`;
                  setPage(nextPage);
                  fetchCandidates(jobDetails, nextPage);
                }
              }}
              hasMore={hasNext}
              loader={
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 30,
                    marginTop: "20px",
                  }}
                >
                  <CircularProgress size={30} color="info" />
                </Box>
              }
              scrollableTarget="offcanvasScroll"
              scrollThreshold={0.9}
            >
              {candidates?.map((recruiter) => {
                return (
                  <SalesRecruiter
                    image={profile_image}
                    name={recruiter?.recruiter_name}
                    emailID={recruiter?.email}
                    status={recruiter?.candidates?.length}
                    handleSelect={handleSelect}
                    candidateId={recruiter?.recruiter_id}
                    recruiter={recruiter}
                    btn2={
                      <>
                        {recruiter?.selected === true ? (
                          <>
                            Selected <TiTick style={{ color: "#fff" }} />
                          </>
                        ) : (
                          "Select"
                        )}
                      </>
                    }
                  />
                );
              })}
            </InfiniteScroll>
          ) : (
            <h6 style={{ textAlign: "center" }}>No Active Bench Sales Found</h6>
          )}
        </Box>
        <Box
          className={styles.mass_update_btns}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <Box>
            <button
              style={{ backgroundColor: "#3856a6", marginRight: "10px" }}
              onClick={() => handleOnClickNextPrevious("previous")}
              disabled={candidateData?.previous === null}
            >
              {massmailStatus === "loading" ? "Loading" : "Prevoius"}
            </button>
            <button
              style={{ backgroundColor: "#3856a6", marginRight: "0" }}
              onClick={() => handleOnClickNextPrevious("next")}
              disabled={candidateData?.next === null}
            >
              {massmailStatus === "loading" ? "Loading" : "Next"}
            </button>
          </Box> */}
          <button
            style={{ backgroundColor: "#4287f5", marginRight: "0" }}
            onClick={handleClickOpen}
          >
            Send Mail
          </button>
          <button
            style={{ backgroundColor: "#3856a6", marginRight: "0" }}
            onClick={handleSelectAll}
          >
            {selectAll ? "Deselect All" : "Select All"}
          </button>
        </Box>
        {/* <Box
          className={styles.mass_update_btns}
          sx={{ justifyContent: "center" }}
        >
          <button
            style={{ backgroundColor: "#4287f5", marginRight: "0" }}
            onClick={handleClickOpen}
          >
            Send Mail
          </button>
        </Box> */}
      </Offcanvas.Body>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        sx={{
          "& .MuiDialog-paper": { width: "40%", maxHeight: "90vh" },
          textAlign: "center",
        }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ color: "#3856a6", marginTop: "10px" }}
        >
          {"Massmail"}
        </DialogTitle>
        <DialogContent>{totalSelectedCredit} credit will debit</DialogContent>

        <DialogActions className="forgot_password_modal_btns">
          <button type="submit" onClick={handleOnClickMassmail}>
            {massmailStatus === "loading" ? "Loading" : "Yes"}
          </button>
          <button type="submit" onClick={handleCloseModal}>
            No
          </button>
        </DialogActions>
      </Dialog>
    </Offcanvas>
  );
}

export default ActiveBenchSalesDrawer;
